export const TOKEN_NAME="RxDragAuthToken";
export const LOGIN_URL = "/login";
export const INDEX_URL = "/apps-index";
